/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

export enum SortOption {
    CreatedDateTimeAscending = 'CreatedDateTimeAscending',
    CreatedDateTimeDescending = 'CreatedDateTimeDescending',
    ConfirmedShipDateAscending = 'ConfirmedShipDateAscending',
    ConfirmedShipDateDescending = 'ConfirmedShipDateDescending'
}
